import { InvoicesType } from 'b2b-common/core/account/api/invoices';
import {
  CLEAR_ACCOUNT_INVOICES,
  FETCH_INVOICES,
  FETCH_INVOICES_FULFILLED,
  FETCH_INVOICES_REJECTED,
} from './actionTypes';
import {
  ClearAccountInvoicesAction,
  FetchInvoicesAction,
  FetchInvoicesFulfilledAction,
  FetchInvoicesRejectedAction,
} from './types';

const fetchInvoices = (pageSize: number, startItem: number): FetchInvoicesAction => ({
  type: FETCH_INVOICES,
  payload: {
    startItem,
    pageSize,
  },
});

const fetchInvoicesFulfilled = (response: InvoicesType): FetchInvoicesFulfilledAction => ({
  type: FETCH_INVOICES_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchInvoicesRejected = (error: ErrorType): FetchInvoicesRejectedAction => ({
  type: FETCH_INVOICES_REJECTED,
  payload: {
    error,
  },
});

const clearAccountInvoices = (): ClearAccountInvoicesAction => ({
  type: CLEAR_ACCOUNT_INVOICES,
});

export {
  clearAccountInvoices,
  fetchInvoices,
  fetchInvoicesFulfilled,
  fetchInvoicesRejected,
};
